<div class="cta-board">
  <div class="cta-board__enterprise-wrapper">
    <div class="action-board__header">
     <span class="icon"><img src="assets/img/icon-building.svg" alt="icon" class="icon-img"></span>
      <span class="action-board__label">企業員工．眷屬 的健檢方案</span>
    </div>

    <div class="action-board__input-row">
      <input type="text" placeholder="請輸入企業代碼" class="action-board__input" [class.input-error]="hasError"
        [formControl]="enterpriseCodeControl" (keydown.enter)="handleEnterpriseClick()" maxlength="10"
        (input)="onInputChange($event)" />
      <button class="btn-primary-teal" [disabled]="isButtonDisabled"
                    (click)="handleEnterpriseClick()">開始預約</button>
    </div>
  </div>

  <div class="cta-board__personal-section">
    <div class="action-board__header">
      <span class="icon"><img src="assets/img/icon-family-users.svg" alt="icon" class="icon-img"></span>
      <span class="action-board__label">個人專屬 的健檢方案</span>
    </div>

    <div class="cta-board__personal-btns">
      <button class="btn-outline-pill" (click)="handlePersonalClick()">
        曾經來過，直接預約 <span class="arrow">→</span>
      </button>
      <button class="btn-outline-pill" (click)="handleQuickReserveClick()">
        第一次來，了解方案 <span class="arrow">→</span>
      </button>
    </div>
  </div>
</div>